export const applyCepMask = (value: string): string => {
	const digits = value.replace(/\D/g, '').slice(0, 8);
	if (digits.length === 0) return '';
	if (digits.length <= 2) return digits;
	if (digits.length <= 5) return digits.replace(/(\d{2})(\d{0,3})/, '$1.$2');
	return digits.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2-$3');
};

export const applySubscriptionMask = (value: string): string => {
	const digits = value.replace(/\D/g, '').slice(0, 9);
	if (digits.length === 0) return '';
	if (digits.length <= 2) return digits;
	if (digits.length <= 5) return digits.replace(/(\d{2})(\d{0,3})/, '$1.$2');
	if (digits.length <= 8) return digits.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
	return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{0,1})/, '$1.$2.$3-$4');
};

export const STATE_TO_UF: Record<string, string> = {
	Acre: 'AC',
	Alagoas: 'AL',
	Amapá: 'AP',
	Amazonas: 'AM',
	Bahia: 'BA',
	Ceará: 'CE',
	'Distrito Federal': 'DF',
	'Espírito Santo': 'ES',
	Goiás: 'GO',
	Maranhão: 'MA',
	'Mato Grosso': 'MT',
	'Mato Grosso do Sul': 'MS',
	'Minas Gerais': 'MG',
	Pará: 'PA',
	Paraíba: 'PB',
	Paraná: 'PR',
	Pernambuco: 'PE',
	Piauí: 'PI',
	'Rio de Janeiro': 'RJ',
	'Rio Grande do Norte': 'RN',
	'Rio Grande do Sul': 'RS',
	Rondônia: 'RO',
	Roraima: 'RR',
	'Santa Catarina': 'SC',
	'São Paulo': 'SP',
	Sergipe: 'SE',
	Tocantins: 'TO',
};

export const stateToUf = (state: string): string => STATE_TO_UF[state] ?? state;

const UF_TO_STATE: Record<string, string> = Object.fromEntries(
	Object.entries(STATE_TO_UF).map(([name, uf]) => [uf, name])
);

export const ufToState = (uf: string): string => UF_TO_STATE[uf] ?? uf;
